import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ChatMessage } from "types/chat"

type Props = {
    message: ChatMessage;
}

const Message = (props: Props) => {
    const { message } = props

    if (message.sender === "bot") {
        const texts = message.results.filter(result => result.type === "text");
        const actions = message.results.filter(result => result.type === "action");
        return (
            <div style={{ textAlign: "left", margin: "5px 0" }}>
                <span
                    className="bot-message"
                >
                    {
                        texts.map((text, idx) => (
                            <div key={idx}>
                                <span>{text.output}</span>
                            </div>
                        ))
                    }
                    <br />
                    {
                        actions.map((action, idx) => (
                            <div key={idx}>
                                <Link to={`?${action.output}`} style={{ textDecoration: "none" }}>
                                    <Button variant="secondary" size="sm">
                                        Apply Changes
                                    </Button>
                                </Link>
                            </div>
                        ))
                    }

                </span>
            </div>
        )
    } else {
        return (
            <div
                style={{
                    textAlign: "right",
                    margin: "5px 0"
                }}
            >
                <span
                    className="user-message"
                >
                    {message.text}
                </span>
            </div>
        )
    }


}

export default Message